export default ".mdc-text-field {\n  width: 100% !important;\n  max-width: 100% !important;\n  border-radius: 0;\n}"